<template>
  <md-autocomplete v-model="selected" class="mo-autocomplete" md-layout="box" :md-options="placesPredictions" @md-changed="getPlacePredictions" @md-selected="selectPrediction">
    <label>{{keywordPlaceholder}}</label>
    <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.description }}</template>
  </md-autocomplete>
</template>

<script>
  import {
    getPlacePredictions,
  } from '../mapsRepository.js'
  export default {
    props: {
      keywordPlaceholder:{
        type: String,
        required:false,
        default: "Address"
      },
      startWithKeyword: String,
      onError: {
        tpye: Function,
        required: true
      },
      onSuccess: Function,
      onPlaceSelected: {
        tpye: Function,
        required: true
      },
      searchType: {
        tpye: String,
        required: true
      },
      selected: {
        tpye: String,
        required: false
      }
    },
    data() {
      return {
        placesPredictions: [],
        filterMuni: undefined,
        placeId: undefined
      };
    },
    computed: {

    },
    created(){
      if(this.startWithKeyword) this.selected = this.startWithKeyword
    },
    methods: {
      selectPrediction(item){
        this.selected = item.description
        this.onPlaceSelected(item)
      },
      getPlacePredictions(searchTerm){
        try{
          var searhTermForUrl = searchTerm.replace(new RegExp(' ', 'g'), '+');
          this.placesPredictions = getPlacePredictions(searhTermForUrl, this.searchType)
            .then(predictions => {
              return predictions
            })
            .catch(err => {
              return []
            })
        }catch(error){
          // This error will the thrown when user select a place and the searchTerm becomes an object, not string.
          // replace(new RegExp...) will throw an exception when not done on string
        }
      }
    }
  }
</script>
<style scoped>
  @import '../assets/styles/add-steps.css';
  @import '../assets/styles/images.css';
  @import '../assets/styles/global.css';

/*
  .mo-search{
    color:grey;
  }
  .mo-search i{
    background: url('../assets/search_small.svg') no-repeat;
    height: 20px;
    width: 20px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
  }

  .mo-search p{
    left: 2em;
    position: relative;
    margin:0;
  }

  .mo-search-bar{
    border-radius: 10px !important;
    margin-bottom: 0;
  } */

</style>



// WEBPACK FOOTER //
// src/components/adrSearchBar.vue